<div class="flex flex-col justify-between min-w-72 rounded-xl border border-[#E7EAF0] shadow-sm">
    <!-- Image -->
    <ngx-skeleton-loader [theme]="{ height: '160px' }"></ngx-skeleton-loader>
    <!-- Content -->
    <div class="flex flex-col gap-2 px-3 pb-3">
        <!-- Title -->
        <ngx-skeleton-loader class="w-40 h-4"></ngx-skeleton-loader>
        <!-- Privacy + Member Count -->
        <div class="flex gap-2">
            <ngx-skeleton-loader class="w-16 h-4"></ngx-skeleton-loader>
            <ngx-skeleton-loader class="w-16 h-4"></ngx-skeleton-loader>
        </div>
    </div>
</div>
